import { useDispatch, useSelector } from 'react-redux'
import { useCallback } from 'react'
import { updatePetAsync } from '../../../../../actions/pets/pets.actions'
import { api } from '../../../../../services/api'

const useGroomingProfile = () => {
	const dispatch = useDispatch()
	const loading = useSelector((state) => state.specific.visits.loading)
	const facility = useSelector((state) => state.specific.facilities.selected)

	const update = useCallback(
		async (pet_id, updates) => {
			if (!pet_id || !updates) {
				return null
			}

			const res = await updatePetAsync(dispatch, pet_id, updates)
			return res
		},
		[dispatch]
	)

	const fetchBreeds = useCallback(async () => {
		const url = '/breeds/dogs/all'
		let result = []
		const breedsObject = {}
		try {
			const { data } = await api.get(url)
			result = data.data
			result.forEach(({ name, coat_type, coat_length, grooming_level }) => {
				breedsObject[name] = {
					coat_type: coat_type || null,
					coat_length: coat_length || null,
					grooming_level: grooming_level || null
				}
			})
		} catch (e) {
			console.log('api > fetchAllDogBreeds > error: ', e)
		} finally {
			return breedsObject
		}
	}, [])

	const sendReferenceImageRequest = useCallback(async () => {
		try {
			const data = new Promise((resolve, _) => resolve({ data: { errors: ['not setup yet'] } })) //await api.post(`/sendReferenceImageEmailToClient/${visit._id}`)
			return data
		} catch (e) {
			console.log(e)
			return null
		}
	}, [])

	return {
		loading,
		facility,
		update,
		fetchBreeds,
		sendReferenceImageRequest
	}
}

export default useGroomingProfile
